import { MantineColor, MantineSpacing } from '@mantine/core';
import { MutableRefObject } from 'react';
import { ChatMode, ChatState, FinalChunkData } from './chat/types';

export type ContentPaneConfig = {
  bg?: MantineColor;
  p?: MantineSpacing;
};

export type ContentMeta = {
  pageType: string;
  entityId?: string;
  metadata?: Record<string, string>;
  chatMode?: ChatMode;
  onChatStateChange?: (state: ChatState, data?: FinalChunkData) => void;
  getDocumentContent?: () => string;
  chatActionsRef?: MutableRefObject<ChatActions | null>;
};

export type ChatActions = {
  replaceLastAssistantMessage: (content: string) => void;
  sendVerifyMessage: (claim: string, sectionPath: string[]) => void;
};

export type SiestaMode = 'action' | 'chat' | 'busy' | 'history';

export const SiestaActionType = {
  LINK: 'link',
  CHAT: 'chat',
} as const;

export type SiestaActionType = (typeof SiestaActionType)[keyof typeof SiestaActionType];

export type DescriptionMode = 'hover' | 'always_visible';

export type SiestaAction =
  | {
      type: typeof SiestaActionType.LINK;
      id: string;
      label: string;
      description?: string;
      descriptionMode?: DescriptionMode;
      href: string;
    }
  | {
      type: typeof SiestaActionType.CHAT;
      id: string;
      label: string;
      description?: string;
      descriptionMode?: DescriptionMode;
      prompt?: string;
    };

export type AppContainerContextValue = {
  skipDefaultSidebar: boolean;
  setSkipDefaultSidebar: (skip: boolean) => void;
  sidebarContent: React.ReactNode | null;
  setSidebarContent: (content: React.ReactNode | null) => void;
  contentMeta: ContentMeta | null;
  setContentMeta: (meta: ContentMeta | null) => void;
  contentPaneConfig: ContentPaneConfig;
  setContentPaneConfig: (config: ContentPaneConfig) => void;
  siestaMode: SiestaMode;
  setSiestaMode: (mode: SiestaMode) => void;
  siestaBusyGlowTop: number | null;
  setSiestaBusyGlowTop: (top: number | null) => void;
  conversationId: string;
  setConversationId: (id: string) => void;
  resetConversationId: () => string;
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  preventSidebarCollapse: boolean;
  setPreventSidebarCollapse: (prevent: boolean) => void;
  sidebarFullScreen: boolean;
  setSidebarFullScreen: (fullScreen: boolean) => void;
};
